<template>
  <div
      class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
      :class="[color === 'light' ? 'bg-white' : 'bg-yellow-900 text-white']"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="px-3 text-center flex justify-between">
        <h3
            class="font-semibold text-lg"
            :class="[color === 'light' ? 'text-blueGray-700' : 'text-white']"
        >
          {{ $tc('manager', 2) }}
        </h3>
        <div>
          <span
              class="z-10 leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3"
          >
            <i class="fas fa-search"></i>
          </span>
          <input
              type="text"
              :placeholder="$t('search')"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow mr-3 outline-none focus:outline-none focus:ring pl-10"
              v-model="filter"
          />
          <button
              class="bg-yellow-400 text-white ative:bg-yellow-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button"
              v-on:click="toggleNewManager"
          >
            <i class="fas fa-plus text-sm mx-auto"></i>

          </button>
        </div>
      </div>
    </div>
    <card-new-locker-manager v-if="showNewManager"/>
    <card-edit-locker-manager v-if="showEditManager" v-bind:index="managerIndex"/>
    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
        <tr>
          <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-yellow-800 text-yellow-300 border-emerald-700',
              ]"
          >
            {{ $t('name') }}
          </th>
          <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-yellow-800 text-yellow-300 border-emerald-700',
              ]"
          >
            {{ $t('surname') }}
          </th>
          <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-yellow-800 text-yellow-300 border-emerald-700',
              ]"
          >
            Email
          </th>
          <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                color === 'light'
                  ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100'
                  : 'bg-yellow-800 text-yellow-300 border-emerald-700',
              ]"
          ></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(manager, index) in filteredManagers">
          <tr v-if="manager.id > 0" :key="manager.id">
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="manager.name === ''">-</div>
              <div v-else>{{ manager.name }}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="manager.surname === ''">-</div>
              <div v-else>{{ manager.surname }}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="manager.email === ''">-</div>
              <div v-else>{{ manager.email }}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
            >
              <locker-managers-dropdown v-bind:index="index"/>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import LockerManagersDropdown from "@/components/Dropdowns/Superuser/LockerManagersDropdown.vue";
import CardNewLockerManager from "@/components/Cards/Superuser/CardNewLockerManager.vue";
import CardEditLockerManager from "@/components/Cards/Superuser/CardEditLockerManager.vue";
import AuthService from "../../../services/auth.service";

export default {
  name: 'Managers',
  data() {
    return {
      managers: [],
      showNewManager: false,
      showEditManager: false,
      managerIndex: '',
      filter: '',
    };
  },

  computed: {
    filteredManagers() {
      return this.managers.filter(user => {
        const name = user.name.toString().toLowerCase();
        const surname = user.surname.toLowerCase();
        const email = user.email.toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return name.includes(searchTerm) || surname.includes(searchTerm) || email.includes(searchTerm);
      });
    }
  },

  mounted: function () {
    AuthService.getManagers().then(
        response => {
          this.managers = response.data.message;
        }
    );
    window.setInterval(() => {
      AuthService.getManagers().then(
          response => {
            this.managers = response.data.message;
          }
      );
    }, 20000)
  },

  methods: {
    toggleNewManager: function () {
      this.showNewManager = !this.showNewManager;
      if (this.showEditManager) this.showEditManager = !this.showEditManager;
    },

    toggleEditManager: function () {
      this.showEditManager = !this.showEditManager;
      if (this.showNewManager) this.showNewManager = !this.showNewManager;
    },

    showManagerDetails: function (manager) {
      this.$parent.$props.manager = manager;
      this.$parent.showManagerDetails = true;
    },

    setManagerIndex: function(index) {
      this.managerIndex = index;
    }
  },

  components: {
    LockerManagersDropdown,
    CardNewLockerManager,
    CardEditLockerManager,
  },
  props: {
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },
};
</script>
